/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-twitter': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19 8.034A5.996 5.996 0 0117.565 9.6a9.12 9.12 0 01-.327 2.826 8.904 8.904 0 01-1.026 2.332 9.07 9.07 0 01-1.644 1.973c-.636.574-1.4 1.03-2.294 1.371-.893.341-1.85.512-2.871.512-1.594 0-3.061-.454-4.403-1.362.238.028.467.041.685.041 1.331 0 2.52-.432 3.567-1.298a2.694 2.694 0 01-1.667-.605 2.98 2.98 0 01-1.014-1.5 2.734 2.734 0 001.297-.05c-.663-.14-1.212-.488-1.649-1.045a3.031 3.031 0 01-.655-1.926v-.037c.407.238.84.364 1.301.38a2.96 2.96 0 01-.933-1.08 3.09 3.09 0 01-.345-1.442c0-.545.13-1.053.388-1.523a8.267 8.267 0 002.62 2.236 7.654 7.654 0 003.3.93c-.05-.22-.076-.45-.076-.689 0-.837.28-1.55.842-2.142.56-.592 1.238-.888 2.03-.888.83 0 1.53.319 2.097.956a5.55 5.55 0 001.824-.736A2.91 2.91 0 0117.35 8.51 5.518 5.518 0 0019 8.034z" _fill="#fff"/>'
  }
})
